import React from 'react';
import { Box } from '@chakra-ui/react';
import Plugin, { PluginProps } from '../Plugin';
import { useIsMobile } from '../../../../../hooks/isMobile';

const ContentSection = (props: PluginProps) => {
  const { content } = props;
  const isMobile = useIsMobile();

  return (
    <Box
      width="100%"
      padding={isMobile ? '1rem' : '2rem'}
      sx={
        isMobile
          ? {
              '& h1': { fontSize: '1.5rem' },
              '& h3': { fontSize: '1.2rem' },
              '& div[style*="border"]': {
                padding: '15px 15px !important',
                margin: '0 !important',
              },
            }
          : {}
      }
    >
      {content.children.map((child, index) => {
        return <Plugin key={index} {...props} content={child} />;
      })}
    </Box>
  );
};

export default ContentSection;
